import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import da from "../src/i18n/da.json";
import de from "../src/i18n/de.json";
import en from "../src/i18n/en.json";
import es from "../src/i18n/es.json";
import fr from "../src/i18n/fr.json";
import it from "../src/i18n/it.json";
import ja from "../src/i18n/ja.json";
import ko from "../src/i18n/ko.json";
import nl from "../src/i18n/nl.json";
import pl from "../src/i18n/pl.json";
import pt from "../src/i18n/pt.json";
import sv from "../src/i18n/sv.json";
import zhHans from "../src/i18n/zh-hans.json";
import zhHant from "../src/i18n/zh-hant.json";
import hu from "../src/i18n/hu.json"; 

const resources = {
  'da': {
    translation: da
  },
  'de': {
    translation: de
  },
  'en': {
    translation: en
  },
  'es': {
    translation: es
  },
  'fr': {
    translation: fr
  },
  'it': {
    translation: it
  },
  'ja': {
    translation: ja
  },
  'ko': {
    translation: ko
  },
  'nl': {
    translation: nl
  },
  'pl': {
    translation: pl
  },
  'pt': {
    translation: pt
  },
  'sv': {
    translation: sv
  },
  'zh-CN': {
    translation: zhHans
  },
  'zh-HK': {
    translation: zhHant
  },
  'zh-TW': {
    translation: zhHant
  },
  'hu': { 
    translation: hu 
  },
};

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
  resources,
  debug: true,
  fallbackLng: "en",
  detection: {
    order: ["navigator"],
    caches: []
  },
  interpolation: {
    escapeValue: false
  }
});

export default i18n;